// @ts-ignore esModuleInterop
import React, { createContext, useContext, ReactNode } from 'react'

interface AiPromptContextValue {
  onClickAiPrompt: (prompt?: string) => void
}

const AiPromptContext = createContext<AiPromptContextValue | undefined>(
  undefined
)

const defaultValue: AiPromptContextValue = {
  onClickAiPrompt: () => {},
}

export const useAiPrompt = (): AiPromptContextValue => {
  const context = useContext(AiPromptContext)
  return context ?? defaultValue
}

interface AiPromptProviderProps {
  children: ReactNode
  onClickAiPrompt: (prompt?: string) => void
}

export const AiPromptProvider = ({
  children,
  onClickAiPrompt,
}: AiPromptProviderProps) => (
  <AiPromptContext.Provider value={{ onClickAiPrompt }}>
    {children}
  </AiPromptContext.Provider>
)
